import styled from 'styled-components';

export const ButtonWrap = styled.div`
  margin-right: 10px;
  display: inline-block;
`;
